import React from 'react';

const CompanyForm = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <>
      <div className="form-group">
        <label>Name:</label>
        <input
          type="text"
          value={data.name}
          onChange={(e) => handleChange('name', e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label>Branche:</label>
        <input
          type="text"
          value={data.sector}
          onChange={(e) => handleChange('sector', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Adresse:</label>
        <input
          type="text"
          value={data.address}
          onChange={(e) => handleChange('address', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Telefon:</label>
        <input
          type="text"
          value={data.phone}
          onChange={(e) => handleChange('phone', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>E-Mail:</label>
        <input
          type="email"
          value={data.email}
          onChange={(e) => handleChange('email', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Website:</label>
        <input
          type="text"
          value={data.website}
          onChange={(e) => handleChange('website', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Bemerkungen:</label>
        <textarea
          value={data.remarks}
          onChange={(e) => handleChange('remarks', e.target.value)}
        />
      </div>
      <div className="form-group checkbox-group">
        <label>
          <input
            type="checkbox"
            checked={data.highlighted}
            onChange={(e) => handleChange('highlighted', e.target.checked)}
          />
          Hervorgehoben
        </label>
        <label>
          <input
            type="checkbox"
            checked={data.contacted}
            onChange={(e) => handleChange('contacted', e.target.checked)}
          />
          Kontaktiert
        </label>
        {/* NEU: Checkbox für Verified */}
        <label>
          <input
            type="checkbox"
            checked={data.verified || false}
            onChange={(e) => handleChange('verified', e.target.checked)}
          />
          Verifiziert
        </label>
        {/* NEU: Checkbox für IsExtern */}
        <label>
          <input
            type="checkbox"
            checked={data.isExtern || false}
            onChange={(e) => handleChange('isExtern', e.target.checked)}
          />
          Ext. Vertrieb
        </label>
      </div>
    </>
  );
};

export default CompanyForm;